<script setup lang="ts">
import { computed } from "vue";

import BaseIframeModal from "@/components/BaseIframeModal.vue";
import type { Organisation } from "@/types";

const { organisation } = defineProps<{
  organisation: Organisation;
}>();

const modalTitle = computed(() => {
  if (organisation.topParentName) {
    return `${organisation.topParentName} - ${organisation.name}`;
  }

  return organisation.name;
});
</script>

<template>
  <BaseIframeModal
    size="xl"
    min-height="500px"
    fullscreen="lg-down"
    is-centered
    :title="modalTitle"
    :src="`/organisations/${organisation.id}`"
  />
</template>
